
  document.addEventListener('DOMContentLoaded', function () {

    /*
     * ============================================================
     * DOG REVIEW CUSTOM SLIDER
     * ============================================================
     *
     * Change only these settings when required.
     *
     * loop: true  -> Infinite slider
     * loop: false -> Normal slider
     *
     * Desktop  -> 3 slides
     * Tablet   -> 2 slides
     * Mobile   -> 1 slide
     *
     * ============================================================
     */

    const DOG_REVIEW_SLIDER_OPTIONS = {
      loop: true,

      breakpoints: {
        mobile: {
          maxWidth: 767,
          slidesPerView: 1,
          gap: 12,
          peek: 20
        },

        tablet: {
          minWidth: 768,
          maxWidth: 991,
          slidesPerView: 2,
          gap: 16,
          peek: 60
        },

        desktop: {
          minWidth: 992,
          slidesPerView: 3,
          gap: 27,
          peek: 97
        }
      },

      transitionSpeed: 450,

      swipe: {
        threshold: 40,
        velocity: 0.25
      }
    };


    /*
     * ============================================================
     * INITIALIZE SLIDER
     * ============================================================
     */

    function initDogReviewSlider(sliderElement) {

      if (!sliderElement) {
        return;
      }

      const track = sliderElement.querySelector(
        '.lp-dog-review-slider-track'
      );

      const prevButton = sliderElement.parentElement.querySelector(
        '.js-lp-dog-review-prev'
      );

      const nextButton = sliderElement.parentElement.querySelector(
        '.js-lp-dog-review-next'
      );

      if (!track) {
        return;
      }

      let originalSlides = Array.from(
        track.querySelectorAll('.lp-dog-review__item')
      );

      if (!originalSlides.length) {
        return;
      }

      let currentIndex = 0;
      let renderedIndex = 0;

      let slidesPerView = 3;
      let gap = 12;
      let peek = 42;

      let cloneCount = 0;

      let isDragging = false;
      let startX = 0;
      let currentX = 0;
      let startTime = 0;

      let isAnimating = false;


      /*
       * ============================================================
       * GET RESPONSIVE SETTINGS
       * ============================================================
       */

      function getSliderSettings() {

        const width = window.innerWidth;

        if (width <= 767) {
          return DOG_REVIEW_SLIDER_OPTIONS.breakpoints.mobile;
        }

        if (width <= 991) {
          return DOG_REVIEW_SLIDER_OPTIONS.breakpoints.tablet;
        }

        return DOG_REVIEW_SLIDER_OPTIONS.breakpoints.desktop;
      }


      /*
       * ============================================================
       * UPDATE SETTINGS
       * ============================================================
       */

      function updateSettings() {

        const settings = getSliderSettings();

        slidesPerView = Math.min(
          settings.slidesPerView,
          originalSlides.length
        );

        gap = settings.gap;
        peek = settings.peek;

      }


      /*
       * ============================================================
       * CREATE LOOP CLONES
       * ============================================================
       */

      function createLoop() {

        // Remove old clones first
        track.querySelectorAll('.is-clone').forEach(function (clone) {
          clone.remove();
        });

        cloneCount = 0;

        if (!DOG_REVIEW_SLIDER_OPTIONS.loop) {
          return;
        }

        /*
         * Clone all slides.
         *
         * This makes the loop reliable even when there are only
         * 4 or 5 reviews.
         */
        const beforeFragment = document.createDocumentFragment();
        const afterFragment = document.createDocumentFragment();

        originalSlides.forEach(function (slide) {

          const beforeClone = slide.cloneNode(true);
          beforeClone.classList.add('is-clone');

          const afterClone = slide.cloneNode(true);
          afterClone.classList.add('is-clone');

          beforeFragment.appendChild(beforeClone);
          afterFragment.appendChild(afterClone);

        });

        track.insertBefore(
          beforeFragment,
          track.firstChild
        );

        track.appendChild(afterFragment);

        cloneCount = originalSlides.length;

      }


      /*
       * ============================================================
       * GET CURRENT SLIDES
       * ============================================================
       */

      function getAllSlides() {

        return Array.from(
          track.querySelectorAll('.lp-dog-review__item')
        );

      }


      /*
       * ============================================================
       * UPDATE CARD WIDTH
       * ============================================================
       */

      function updateCardWidth() {

        const viewportWidth = sliderElement.clientWidth;

        /*
         * Formula:
         *
         * viewport
         * - left peek
         * - right peek
         * - gaps
         * ----------------
         * slidesPerView
         *
         * Example desktop:
         *
         * 100% - 42px - 42px - 24px
         * --------------------------------
         *                 3
         *
         * This gives 3 complete cards + partial cards.
         */

        const totalGaps =
          gap * Math.max(slidesPerView - 1, 0);

        const availableWidth =
          viewportWidth -
          (peek * 2) -
          totalGaps;

        const cardWidth =
          availableWidth / slidesPerView;

        track.style.setProperty(
          '--dog-review-card-width',
          `${cardWidth}px`
        );

        track.style.setProperty(
          '--dog-review-gap',
          `${gap}px`
        );

        track.style.setProperty(
          '--dog-review-peek',
          `${peek}px`
        );

        track.style.setProperty(
          '--dog-review-step',
          `${cardWidth + gap}px`
        );

      }


      /*
       * ============================================================
       * GET TRANSLATE POSITION
       * ============================================================
       */

      function getTranslateX(index) {

        const step =
          parseFloat(
            getComputedStyle(track)
              .getPropertyValue('--dog-review-step')
          ) || 0;

        return peek - (index * step);

      }


      /*
       * ============================================================
       * UPDATE ACTIVE/VISIBLE CLASSES
       * ============================================================
       */

      function updateVisibleSlides() {

        const slides = getAllSlides();

        slides.forEach(function (slide) {
          slide.classList.remove('is-visible');
        });

        /*
         * Mark the 3 visible full cards.
         */
        for (
          let i = renderedIndex;
          i < renderedIndex + slidesPerView;
          i++
        ) {

          if (slides[i]) {
            slides[i].classList.add('is-visible');
          }

        }

      }


      /*
       * ============================================================
       * MOVE SLIDER
       * ============================================================
       */

      function moveTo(
        index,
        animate = true
      ) {

        const slides = getAllSlides();

        if (!slides.length) {
          return;
        }

        renderedIndex = index;

        track.style.transition = animate
          ? `transform ${DOG_REVIEW_SLIDER_OPTIONS.transitionSpeed}ms cubic-bezier(0.22, 0.61, 0.36, 1)`
          : 'none';

        track.style.transform =
          `translate3d(${getTranslateX(index)}px, 0, 0)`;

        updateVisibleSlides();

      }


      /*
       * ============================================================
       * INITIAL POSITION
       * ============================================================
       */

      function setInitialPosition() {

        updateSettings();
        updateCardWidth();

        if (DOG_REVIEW_SLIDER_OPTIONS.loop) {

          currentIndex = 0;

          moveTo(
            cloneCount,
            false
          );

        } else {

          currentIndex = 0;

          moveTo(
            0,
            false
          );

        }

      }


      /*
       * ============================================================
       * NEXT
       * ============================================================
       */

      function nextSlide() {

        if (isAnimating) {
          return;
        }

        if (DOG_REVIEW_SLIDER_OPTIONS.loop) {

          isAnimating = true;

          currentIndex++;

          moveTo(
            cloneCount + currentIndex,
            true
          );

        } else {

          const maxIndex =
            Math.max(
              originalSlides.length - slidesPerView,
              0
            );

          if (currentIndex >= maxIndex) {
            return;
          }

          currentIndex++;

          moveTo(
            currentIndex,
            true
          );

          updateButtons();

        }

      }


      /*
       * ============================================================
       * PREVIOUS
       * ============================================================
       */

      function prevSlide() {

        if (isAnimating) {
          return;
        }

        if (DOG_REVIEW_SLIDER_OPTIONS.loop) {

          isAnimating = true;

          currentIndex--;

          moveTo(
            cloneCount + currentIndex,
            true
          );

        } else {

          if (currentIndex <= 0) {
            return;
          }

          currentIndex--;

          moveTo(
            currentIndex,
            true
          );

          updateButtons();

        }

      }


      /*
       * ============================================================
       * HANDLE LOOP RESET
       * ============================================================
       */

      function handleTransitionEnd() {

        if (!DOG_REVIEW_SLIDER_OPTIONS.loop) {

          isAnimating = false;

          return;
        }

        /*
         * Moved after the last original slide.
         *
         * Example:
         *
         * 1 2 3 4 5
         *       1 2 3
         *
         * Reset back to the real first slide.
         */
        if (
          currentIndex >= originalSlides.length
        ) {

          currentIndex = 0;

          moveTo(
            cloneCount,
            false
          );

        }

        /*
         * Moved before the first original slide.
         */
        else if (currentIndex < 0) {

          currentIndex =
            originalSlides.length - 1;

          moveTo(
            cloneCount + currentIndex,
            false
          );

        }

        isAnimating = false;

      }


      /*
       * ============================================================
       * BUTTON STATE
       * ============================================================
       */

      function updateButtons() {

        if (
          DOG_REVIEW_SLIDER_OPTIONS.loop
        ) {

          prevButton?.classList.remove(
            'swiper-button-disabled'
          );

          nextButton?.classList.remove(
            'swiper-button-disabled'
          );

          return;

        }

        const maxIndex =
          Math.max(
            originalSlides.length - slidesPerView,
            0
          );

        if (prevButton) {

          prevButton.classList.toggle(
            'swiper-button-disabled',
            currentIndex <= 0
          );

        }

        if (nextButton) {

          nextButton.classList.toggle(
            'swiper-button-disabled',
            currentIndex >= maxIndex
          );

        }

      }


      /*
       * ============================================================
       * TOUCH / MOUSE SWIPE
       * ============================================================
       */

      function dragStart(event) {

        if (isAnimating) {
          return;
        }

        isDragging = true;

        startTime = Date.now();

        if (event.type === 'mousedown') {
          startX = event.clientX;
        } else {
          startX = event.touches[0].clientX;
        }

        currentX = startX;

        track.style.transition = 'none';

        sliderElement.classList.add(
          'is-dragging'
        );

      }


      function dragMove(event) {

        if (!isDragging) {
          return;
        }

        if (event.type === 'mousemove') {
          currentX = event.clientX;
        } else {
          currentX = event.touches[0].clientX;
        }

        const difference =
          currentX - startX;

        /*
         * Prevent vertical scrolling from being
         * affected too much on mobile.
         */
        if (event.cancelable) {
          event.preventDefault();
        }

        const baseTranslate =
          getTranslateX(renderedIndex);

        track.style.transform =
          `translate3d(${baseTranslate + difference}px, 0, 0)`;

      }


      function dragEnd() {

        if (!isDragging) {
          return;
        }

        isDragging = false;

        sliderElement.classList.remove(
          'is-dragging'
        );

        const difference =
          currentX - startX;

        const elapsed =
          Math.max(
            Date.now() - startTime,
            1
          );

        const velocity =
          Math.abs(difference) / elapsed;

        const shouldSwipe =
          Math.abs(difference) >=
            DOG_REVIEW_SLIDER_OPTIONS.swipe.threshold
          ||
          velocity >=
            DOG_REVIEW_SLIDER_OPTIONS.swipe.velocity;

        if (shouldSwipe) {

          if (difference < 0) {
            nextSlide();
          } else {
            prevSlide();
          }

        } else {

          moveTo(
            renderedIndex,
            true
          );

        }

      }


      /*
       * ============================================================
       * EVENT LISTENERS
       * ============================================================
       */

      if (nextButton) {

        nextButton.addEventListener(
          'click',
          nextSlide
        );

      }

      if (prevButton) {

        prevButton.addEventListener(
          'click',
          prevSlide
        );

      }


      // Touch
      sliderElement.addEventListener(
        'touchstart',
        dragStart,
        { passive: true }
      );

      sliderElement.addEventListener(
        'touchmove',
        dragMove,
        { passive: false }
      );

      sliderElement.addEventListener(
        'touchend',
        dragEnd
      );


      // Mouse
      sliderElement.addEventListener(
        'mousedown',
        dragStart
      );

      document.addEventListener(
        'mousemove',
        dragMove
      );

      document.addEventListener(
        'mouseup',
        dragEnd
      );


      /*
       * ============================================================
       * TRANSITION END
       * ============================================================
       */

      track.addEventListener(
        'transitionend',
        function (event) {

          if (
            event.propertyName === 'transform'
          ) {

            handleTransitionEnd();

          }

        }
      );


      /*
       * ============================================================
       * RESIZE
       * ============================================================
       */

      let resizeTimer;

      window.addEventListener(
        'resize',
        function () {

          clearTimeout(resizeTimer);

          resizeTimer = setTimeout(
            function () {

              updateSettings();

              /*
               * Rebuild clones when breakpoint changes.
               */
              createLoop();

              updateCardWidth();

              if (
                DOG_REVIEW_SLIDER_OPTIONS.loop
              ) {

                moveTo(
                  cloneCount + currentIndex,
                  false
                );

              } else {

                const maxIndex =
                  Math.max(
                    originalSlides.length -
                    slidesPerView,
                    0
                  );

                currentIndex =
                  Math.min(
                    currentIndex,
                    maxIndex
                  );

                moveTo(
                  currentIndex,
                  false
                );

              }

              updateButtons();

            },
            150
          );

        }
      );


      /*
       * ============================================================
       * PREVENT IMAGE DRAG
       * ============================================================
       */

      sliderElement
        .querySelectorAll('img')
        .forEach(function (img) {

          img.addEventListener(
            'dragstart',
            function (event) {
              event.preventDefault();
            }
          );

        });


      /*
       * ============================================================
       * START SLIDER
       * ============================================================
       */

      updateSettings();

      createLoop();

      updateCardWidth();

      setInitialPosition();

      updateButtons();

    }


    /*
     * ============================================================
     * INITIALIZE ALL DOG REVIEW SLIDERS
     * ============================================================
     */

    document
      .querySelectorAll(
        '.js-lp-dog-review-slider'
      )
      .forEach(function (slider) {

        initDogReviewSlider(slider);

      });

  });

